// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.

import { Application } from 'stimulus'
import { definitionsFromContext } from "stimulus/webpack-helpers"
import Chart from "stimulus-chartjs"
import PasswordVisibility from 'stimulus-password-visibility'

const application = Application.start()
// window.Stimulus = Application.start()
const context = require.context("controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))
application.register("chart", Chart)
application.register('password-visibility', PasswordVisibility)